import React from "react";
import styles from "./ResearchTeamBudgetPeriodSelection.css";


const ResearchTeamBudgetPeriodSelection = props => {
	const { Components, onChange, researchTeamBudget } = props;

	const validateIsRequired = (value, errors = []) => {
		if (!isPresent(value)) {
			errors.push("isRequired");
		}

		return errors;
	};

	const isPresent = value => {
		return value !== undefined && value !== null && value !== "";
	};


	const getDateConfig = (index, name) => {
		const disabled = (index === 0 && name === "startDate") || (index === researchTeamBudget.length - 1 && name === "endDate");

		return {
			label: "",
			$path: `${index}.${name}`,
			type: "date",
			enabled: !disabled,
			$errors: validateIsRequired(researchTeamBudget[index].budgetPeriod[name]),
			value: researchTeamBudget[index].budgetPeriod[name],
			extraSettings: {
				format: "MM/DD/YYYY"
			}
		};
	};

	const changePeriodDate = (date, index, name) => {
		researchTeamBudget[index].budgetPeriod[name] = date;
		onChange([ ...researchTeamBudget ]);
	};

	//TODO: add dictionary
	return (

		<>
			{researchTeamBudget && researchTeamBudget.map((budgetPeriod, index) => (
				<div className={styles.dateRow} key={index}>
                    Budget Period {index + 1}:

					<Components.date {...props} config={getDateConfig(index, "startDate")}
						key={index + 1 + "sd"}
						ckey={index + 1 + "sd"}
						className={styles.date}
						onChange={date => changePeriodDate(date, index, "startDate")}
					/>

					<Components.date {...props} config={getDateConfig(index, "endDate")} key={index + 1 + "ed"}
						ckey={index + 1 + "ed"} enabled={false} className={styles.date}
						onChange={date => changePeriodDate(date, index, "endDate")}
					/>


				</div>
			))}
		</>
	);
};

export default ResearchTeamBudgetPeriodSelection;